import React from 'react';
import {
  Grid,
  Typography,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Box
} from '@mui/material';
import {
  locationMap,
  categoryMap,
  statusMap,
  translateValue
} from '../../../utils/productMappings';

const ProductBasicInfo = ({ product, editedProduct, setEditedProduct, editMode }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedProduct(prev => ({ ...prev, [name]: value }));
  };

  const renderReadonlyField = (label, value) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>{label}</Typography>
      <Typography variant="body2">{value || 'Brak danych'}</Typography>
    </Box>
  );

  if (!product) return null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Podstawowe informacje
        </Typography>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {editMode ? (
          <TextField
            fullWidth
            label="Nazwa produktu"
            name={product.category === 'jewelry' ? 'jewelry_name' : 'name'}
            value={editedProduct.category === 'jewelry' ? (editedProduct.jewelry_name || '') : (editedProduct.name || `${editedProduct.brand || ''} ${editedProduct.model || ''}`.trim())}
            onChange={handleChange}
            margin="normal"
            helperText={product.category !== 'jewelry' ? "Nazwa generowana automatycznie z marki i modelu" : ""}
            disabled={product.category !== 'jewelry'}
          />
        ) : (
          renderReadonlyField('Nazwa produktu', product.jewelry_name || `${product.brand || ''} ${product.model || ''}`.trim() || product.name)
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {editMode ? (
          <TextField
            fullWidth
            label="Cena (PLN)"
            name="price"
            type="number"
            value={editedProduct.price || ''}
            onChange={handleChange}
            margin="normal"
          />
        ) : (
          renderReadonlyField('Cena', `${product.price} PLN`)
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {renderReadonlyField('ID', product.sku)}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {editMode ? (
          <FormControl fullWidth margin="normal">
            <InputLabel>Kategoria</InputLabel>
            <Select
              name="category"
              value={editedProduct.category || ''}
              onChange={handleChange}
              label="Kategoria"
            >
              {Object.entries(categoryMap).map(([key, value]) => (
                <MenuItem key={key} value={key}>{value}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          renderReadonlyField('Kategoria', translateValue(product.category, categoryMap))
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {editMode ? (
          <FormControl fullWidth margin="normal">
            <InputLabel>Lokalizacja</InputLabel>
            <Select
              name="location"
              value={editedProduct.location || ''}
              onChange={handleChange}
              label="Lokalizacja"
            >
              {Object.entries(locationMap).map(([key, value]) => (
                <MenuItem key={key} value={key}>{value}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          renderReadonlyField('Lokalizacja', translateValue(product.location, locationMap))
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        {editMode ? (
          <FormControl fullWidth margin="normal">
            <InputLabel>Status</InputLabel>
            <Select
              name="status"
              value={editedProduct.status || ''}
              onChange={handleChange}
              label="Status"
            >
              {Object.entries(statusMap).map(([key, value]) => (
                <MenuItem key={key} value={key}>{value}</MenuItem>
              ))}
            </Select>
          </FormControl>
        ) : (
          renderReadonlyField('Status', translateValue(product.status, statusMap))
        )}
      </Grid>
    </Grid>
  );
};

export default ProductBasicInfo;
